import SuggestEditModalBody from './SuggestEditModalBody';

export default SuggestEditModalBody;
